import { DeviceContext } from 'context/Device'
import { useContext } from 'react'

const useDevice = () => {
  const context = useContext(DeviceContext)
  if (!context) {
    throw new Error('Context is missing!')
  }

  return context
}

export default useDevice
